var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantagesWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 153,
    viewBox: "0 0 1440 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 14L0 0V153H1440V43L1380 72C1378.42 72.7378 1376.8 73.4965 1375.13 74.2741C1313.68 103.007 1196.84 157.631 1080 144C1016.89 136.111 953.778 108.584 890.667 81.0564C833.778 56.243 776.889 31.4296 720 21C643.2 7.56 566.4 20.3344 489.6 33.1088C446.4 40.2944 403.2 47.48 360 50C243.162 56.8155 126.324 29.5034 64.8671 15.1371C63.2038 14.7483 61.5811 14.3689 60 14Z",
    fill: "#3C73FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantagesWave);
export default __webpack_public_path__ + "static/media/AdvantagesWave.82ee6e0a0a267b7d189f7851c18a079b.svg";
export { ForwardRef as ReactComponent };